import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import StepGeneralFormContainer from '../../../containers/portfolio/PortfolioFormContainers/StepGeneralFormContainer.jsx';

const NewPortfolioStepGeneral = ({ slug }) => (
  <>
    <Helmet>
      <title>New {getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <StepGeneralFormContainer slug={slug} />
  </>
);

NewPortfolioStepGeneral.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewPortfolioStepGeneral));
